export default {"src":"/_next/static/image/public/images/ic_consent.42f012dbac9c0ac724e5b3e50b93e855.svg","height":20,"width":21};